module.exports = __webpack_public_path__ + "img/modal-cl-accept.0e4a642a.svg";